import styles from './TypingIndicator.module.css'

export function TypingIndicator() {
  return (
    <div className={styles.indicator}>
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
    </div>
  )
}
